"use client";

import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { Button, Icon } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC } from "react";
import { useCookies } from "react-cookie";

import { setCookie } from "@/app/_actions/setCookie";
import { useGTMContext } from "@/providers";

export const LandingTryFreeButton: FC = () => {
  const t = useTranslations("Landing");
  const { sendGTM } = useGTMContext();
  const [cookies] = useCookies([
    COOKIES.RULES_ACCEPTED,
    COOKIES.GA_AB,
    COOKIES.GA_ABC,
    COOKIES.SEGMENT_AB,
  ]);
  const rulesAccepted = Number(cookies.rulesAccepted) === 1;

  const onTryFree = async () => {
    sendGTM({ event: GE.CHOOSETRYFREE });

    await setCookie(COOKIES.APP, "1", {
      maxAge: COOKIES_TIMES.DAY_1,
    });
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <Button
      startContent={<Icon icon="language" />}
      size="xl"
      color="primary"
      wide
      centerText
      onClick={onTryFree}
      disabled={!rulesAccepted}
    >
      {t("tryForFree")}
    </Button>
  );
};
